import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ActivityIndicator,
} from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

/**
 * Transaction Processing Content - Shows spinner while payment is being processed
 */
export const TransactionProcessingContent: React.FC = () => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <View style={styles.container}>
      {/* Spinner */}
      <View style={styles.spinnerContainer}>
        <ActivityIndicator
          size="large"
          color={MARKETPLACE_COLORS.accentBlueSolid}
        />
      </View>

      {/* Processing Text */}
      <Text style={[styles.processingText, { color: MARKETPLACE_COLORS.textPrimary }]}>
        Transaction details are sending. Please wait. This should only take a few moments.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingHorizontal: 32,
  },
  spinnerContainer: {
    marginBottom: 24,
  },
  processingText: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24,
    textAlign: 'center',
    maxWidth: 280,
  },
});

export default TransactionProcessingContent;

